<template>
  <button @click="getLocation" class="absolute bottom-0 right-0 mr-4 p-2 mb-20 flex justify-center items-center bg-white border border-section_border rounded-lg shadow-sm">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="m515.425825 299.857165c.321429 0 .616072-.174107.763393-.46875l8.571439-17.142878c.174108-.334822.107143-.736608-.160714-.991072-.160715-.174108-.375001-.254465-.602679-.254465-.133929 0-.267858.026786-.388394.09375l-17.142877 8.571439c-.348215.174107-.535715.575893-.441965.964287.09375.388393.428572.656251.830358.656251h7.714295v7.714294c0 .401787.267857.736608.656251.830359.066964.013392.133928.026785.200893.026785z" transform="translate(-503 -278)"/>
  </svg>
  </button>
</template>

<script>
export default {
  methods: {
    getLocation: function () {
      if (!navigator.geolocation) {
        alert(this.$t('map_location_error_message'))
        return
      }
      this.$store.dispatch('geolocation/fetchLocation')
        .then(() => {
          const fromLocation = this.$store.getters['geolocation/getLocation']
          this.$emit('getLocation', fromLocation)
        })
        .catch(() => {
          const errorCode = this.$store.getters['geolocation/getErrorCode']
          this.handleError(errorCode)
        })
    },
    handleError: function (errorCode) {
      switch (errorCode) {
        case 1: //PERMISSION_DENIED
          alert(this.$t('map_permission_denied_error_message'))
          break
        case 2: //POSITION_UNAVAILABLE
          alert(this.$t('map_position_unavailable_error_message'))
          break
        case 3: //TIMEOUT
          alert(this.$t('map_timeout_error_message'))
          break
        default:
          alert(this.$t('map_default_error_message'))
          break
      }
    }
  }
}
</script>
